import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, FormGroup, Label, Alert, Row, Col } from 'reactstrap';
import Papa from 'papaparse'; 
import Draggable from 'react-draggable';

const OohLocationAudienceModal = ({ isOpen, toggle, onCreate }) => {
  const [audienceName, setAudienceName] = useState('');
  const [csvFile, setCsvFile] = useState(null);
  const [locationCount, setLocationCount] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const today = new Date().toISOString().split('T')[0];
  const handleCsvUpload = (e) => {
    const file = e.target.files[0];
    setCsvFile(file);

    Papa.parse(file, {
      header: true,
      complete: (results) => {
        const rows = results.data;
        const headers = results.meta.fields;

        if (headers.includes('lat') && headers.includes('lon') && headers.includes('name')) {
          const count = rows.length;
          setLocationCount(count);
          setErrorMessage('');
        } else {
          setLocationCount(null);
          setErrorMessage('CSV format is incorrect. Please upload a file with lat, lon, and name columns.');
        }
      },
      error: (error) => {
        console.error('Error parsing CSV:', error);
        setErrorMessage('An error occurred while reading the CSV file.');
      },
    });
  };

  const handleCreate = () => {
    if (audienceName && csvFile && startDate && endDate && !errorMessage) {
      onCreate(audienceName, csvFile, startDate, endDate);
      toggle(); 
    } else if (!startDate || !endDate) {
      setErrorMessage('Please select a valid time range.');
    }
  };

  return (
    <Draggable handle=".modal-header">
    <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
      <ModalHeader toggle={toggle}>Create New OOH Location Audience</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label for="audienceName">Audience Name</Label>
          <Input
            type="text"
            id="audienceName"
            placeholder="Enter audience name"
            value={audienceName}
            onChange={(e) => setAudienceName(e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <Label for="csvUpload">Upload CSV</Label>
          <Input type="file" id="csvUpload" accept=".csv" onChange={handleCsvUpload} />
        </FormGroup>

        <Row form className="mb-3">
          <Label for="startDate">
            Time Range
          </Label>

          <Col md={6}>
            <FormGroup>
              <div className="input-group">
                <span className="input-group-text">Start</span>
                <Input type="date" id="startDate" value={startDate} onChange={(e) => setStartDate(e.target.value)} max={endDate} />
              </div>
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <div className="input-group">
                <span className="input-group-text">End</span>
                <Input type="date" id="endDate" value={endDate} onChange={(e) => setEndDate(e.target.value)} min={startDate} max={today}/>
              </div>
            </FormGroup>
          </Col>
        </Row>

        {errorMessage && <Alert color="danger">{errorMessage}</Alert>}
        {locationCount !== null && !errorMessage && (
          <p>{locationCount} locations found in the uploaded CSV file.</p>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleCreate} disabled={!audienceName || !csvFile || !!errorMessage}>
          Create Audience
        </Button>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
    </Draggable>
  );
};

export default OohLocationAudienceModal;
